import { assignVars, createTheme } from '@vanilla-extract/css';
import { style } from '../layer.css';
import { baseThemeTokens, baseThemeVars } from './base-vars.css';
import {
  componentDarkTokens,
  componentLightTokens,
  componentVars,
} from './component-vars.css';
import { smTokens, smVars } from './semantic-vars.css';

export const baseTheme = createTheme(baseThemeVars, baseThemeTokens, 'base');

const ldVars = {
  ...smVars,
  ...componentVars,
};

const lightTokens = {
  ...smTokens,
  ...componentLightTokens,
} as const;

export const lightTheme = createTheme(ldVars, lightTokens, 'light');

const darkTokens = {
  ...smTokens,
  ...componentDarkTokens,
} as const;

export const darkTheme = createTheme(ldVars, darkTokens, 'dark');

export const systemTheme = style(
  {
    vars: assignVars(ldVars, lightTokens),

    '@media': {
      '(prefers-color-scheme: dark)': {
        vars: assignVars(ldVars, darkTokens),
      },
    },
  },
  'system',
);
